import { AudienceDefinition } from "@models/audienceDefinition.model";
import { CommandGetEngagementAudiences } from "./commands/cmdGetEngagementAudiences";
import { CommandCreateAudienceDefinition, CreateAudiencePayload } from "./commands/cmdCreateAudienceDefinition";
import { CommandUpdateAudienceDefinition, UpdateAudiencePayload } from "./commands/cmdUpdateAudienceDefinition";
import { CommandCalculateAudience } from "src/shared/services/engagements/launch/audience/commands/cmdCalculateAudience";
import { Job } from "@models/job.model";
import { CommandLinkAdsToAudience } from "./commands/cmdLinkAdsToAudience";
import { CommandListAdsInAudience } from "./commands/cmdListAdsInAudience";
import { CommandUnlinkAdsToAudience } from "./commands/cmdUnlinkAdsToAudience";
import { CommandGetMemberJourneyMap } from "./commands/cmdGetMemberJourneyMap";
import { CommandListAudienceMembers } from "./commands/cmdListAudienceMembers";
import { MemberJourneyMap } from "@models/journeyMap.model";
import { AudienceMembersPage } from "@models/audienceMember.model";

export class AudienceDefinitionService {
  async listAudiences(engagementId: number): Promise<AudienceDefinition[]> {
    return await new CommandGetEngagementAudiences().run(engagementId);
  }

  async createAudience(engagementId: number, payload: CreateAudiencePayload): Promise<AudienceDefinition> {
    return await new CommandCreateAudienceDefinition().run(engagementId, payload);
  }

  async updateAudience(audienceId: number, payload: UpdateAudiencePayload): Promise<AudienceDefinition> {
    return await new CommandUpdateAudienceDefinition().run(audienceId, payload);
  }

  async calculateAudience(audienceId: number): Promise<Job> {
    return await new CommandCalculateAudience().run(audienceId);
  }

  async linkAds(launchId: number, adGroupId: number, adIds: number[]) {
    return await new CommandLinkAdsToAudience().run(launchId, adGroupId, adIds)
  }

    async unLinkAds(launchId:number, adGroupId: number, adId: number) {
    return await new CommandUnlinkAdsToAudience().run(launchId, adGroupId, adId)
  }

  async listAds(launchId: number, adGroupId: number, expand?: string, status?: string) {
    return await new CommandListAdsInAudience().run(launchId, adGroupId, expand, status)
  }

  async getMemberJourneyMap(audienceId: number, memberId: number): Promise<MemberJourneyMap> {
    return await new CommandGetMemberJourneyMap().run(audienceId, memberId);
  }

  async listAudienceMembers(audienceId: number, limit: number, offset: number): Promise<AudienceMembersPage> {
    return await new CommandListAudienceMembers().run(audienceId, limit, offset);
  }
}